document.addEventListener('turbo:load', () => {
  const subnavDropdowns = document.getElementsByClassName('navbar-dropdown')

  Array.from(subnavDropdowns).forEach(subNavDropdown => {
    subNavDropdown.addEventListener('click', () => {
      if (window.innerWidth >= 992) { return }
      Array.from(subNavDropdown.parentElement.children).forEach(sibling => {
        if (sibling !== subNavDropdown) {
          sibling.classList.toggle('d-none')
        }
      })
    })
  })
})
